import { FormikControl, useTranslation, ButtonStyle, Button, useState } from "@/imports-files/common/common";
import {CompetencyComponent} from '@/components/jobScorecardComponent/competency';
import {JOB_COMPETENCY_ATTRIBUTES_HASH, job_competency_attr_hash} from '@/constants/pages/clients/jobs/scorecards';
import {CreateScoreStyle, CloseSvg} from '@/imports-files/pages/clients/jobs/scorecards'
import Modal from '@/components/common-modal/modal';
import cloneDeep from 'lodash.clonedeep';
import {ConfirmationModal} from '@/components/confirmation-modal';
import AddCompetencyIcon from 'public/icons/thick-plus.svg';
import AddCompetencyDisableIcon from 'public/images/pages/scorecard/default-primary-disabled-add-btn.svg';

export function CreateJobScorecardComponent(props)
{
  const { t, i18n } =   useTranslation();
  const [flagForRender, setFlagForRender] =   useState();
  const [confirmationModal, setConfirmationModal] = useState({index: null, show:false});
  const formDisabled = !props.editable

  return(
            <div className={`${CreateScoreStyle.CreateScoreCard}`}>
            {props.formik.values.job_competencies_attributes.map((competency,index) => {
                    return (
                                competency?._destroy ? '' : <div className={`${CreateScoreStyle.CreateScoreCard__Card} ${!props.editable ? 'competency-disabled' : CreateScoreStyle.CreateScoreCard__Card}`} key={`CreateJobScorecardComponent__${index}`}>
                                                            <CompetencyComponent formik      = {props.formik}
                                                                                 names       = {{subcompetency: `job_competencies_attributes.${index}.job_sub_competencies_attributes.name`, competency: `job_competencies_attributes.${index}.client_competency_attributes.name`}}
                                                                                 index       = {index}
                                                                                 createscore = {CreateScoreStyle}
                                                                                 jobId       = {props.jobId}
                                                                                 editable    = {props.editable}
                                                                                 clientId    = {props.clientId}
                                                                                 setDirtyArray = {props.setDirtyArray}
                                                                                 closeCompetency = {closeCompetency}
                                                                                 setConfirmationModal = {setConfirmationModal}
                                                                                 job_status = {props.job_status}
                                                                                 setFlagForRender = {setFlagForRender}
                                                                                 />
                                </div>
                            )
                    }
                )
            }
            
      <div
        className={`${CreateScoreStyle.Button} ${
          !props.editable ? "competency-disabled" : ""
        }`}
      >
        <Button
          onClick={() => {
            if (props.editable) {
              props.setDirtyArray(true);
              competenciesAction(props.formik, "add", null, setFlagForRender);
            }
          }}
          disabled={!props.editable || formDisabled}
          className={`${ButtonStyle.iconTextButton} pb32`}
        >
          <AddCompetencyIcon />
          {t("jobs:scorecards:add_competency")}
        </Button>
      </div>

            

       {confirmationModal.show && (
        <Modal
          type="confirmation"
          message={t("modal:confirmation:remove_last_competency")}
          texts={{ button2_text: "Confirm" }}
          closeModal={() => {
            setConfirmationModal({
              index: confirmationModal.index,
              show: false,
            });
          }}
          btnAction={() => {
            setComptencyDetroyTrue(props.formik, confirmationModal.index);
            setConfirmationModal({
              index: confirmationModal.index,
              show: false,
            });
          }}
        />
      )}

            </div>
         )
}


export function closeCompetency(index, formik, setFlagForRender, setConfirmationModal, job_status)
{
    let competency_list = formik.values.job_competencies_attributes;
    let competency_count = 0; 
    for(let competency of competency_list)
    {   
          if( !competency?._destroy )
          {
              competency_count = competency_count + 1;
          }
    } 

    if(competency_count == 1 && job_status == 'Published')
    {
        setConfirmationModal({index: index, show:true});
    }
    else
    {
        setComptencyDetroyTrue(formik,index);
        removeCompetencyIfCreated(formik,index);
        setFlagForRender(Math.random()*1000);
    }
}

export function competenciesAction(formik, type, index=null, setFlagForRender)
{
  // let job_competency_hash = cloneDeep(JOB_COMPETENCY_ATTRIBUTES_HASH);
  let job_competency_hash = job_competency_attr_hash()
  switch (type) {
    case 'add': formik.values.job_competencies_attributes.push(job_competency_hash);
                setFlagForRender(Math.random()*1000)
                break;
    default:''

}}


export function setComptencyDetroyTrue(formik, index)
{
    formik.values.job_competencies_attributes[index]['_destroy'] = true;
}


export function removeCompetencyIfCreated(formik, index)
{
    let job_competencies_attributes = formik.values.job_competencies_attributes;
    if(!formik.values.job_competencies_attributes[index]['id'] || formik.values.job_competencies_attributes[index]['id'] == '')
    {
        job_competencies_attributes.splice(index, 1);
        formik.setFieldValue(`job_competencies_attributes`, job_competencies_attributes);
    }
}
